import React from "react";
import { styled } from "@mui/material/styles";
import Badge from "@mui/material/Badge";
import { ETipoCredito } from "api/types/originacion/businessTypes";
import pxToRem from "libs/pxToRem";

const buildLabel = (background: string, foreground: string) =>
  styled(Badge)({
    display: "inline-block",
    paddingLeft: pxToRem(8),
    paddingRight: pxToRem(8),
    "& .MuiBadge-badge": {
      backgroundColor: background,
      color: foreground,
      transform: "scale(1)",
      position: "relative",
    },
  });

const RedLabel = buildLabel("#dd4e11", "white");
const GreenLabel = buildLabel("#4ca793", "white");
const BlueLabel = buildLabel("#c7f2fa", "#009bba");

const TipoCreditoLabel: React.FC<{
  tipoCredito: ETipoCredito;
}> = ({ tipoCredito }) => {
  switch (tipoCredito) {
    case ETipoCredito.Prendario:
      return <GreenLabel badgeContent="Prendario" overlap="rectangular" />;
    case ETipoCredito.Autoprenda:
      return <RedLabel badgeContent="Autoprenda" overlap="rectangular" />;
    case ETipoCredito.Consumo:
      return <BlueLabel badgeContent="Consumo" overlap="rectangular" />;
    default:
      return <BlueLabel badgeContent="Error" overlap="rectangular" />;
  }
};

export default TipoCreditoLabel;
